import { c as _c } from "react/compiler-runtime";
import { formatMoney } from "@justhome/common";
import useLanguage from "@lib/hooks/useLanguage";
import { FC } from "react";
interface MoneyProps {
  value: string | number | undefined;
  fractionDigits?: boolean;
}
const Money: FC<MoneyProps> = t0 => {
  const $ = _c(4);
  const {
    value,
    fractionDigits
  } = t0;
  const locale = useLanguage();
  let t1;
  if ($[0] !== fractionDigits || $[1] !== locale || $[2] !== value) {
    t1 = formatMoney(value, fractionDigits, locale);
    $[0] = fractionDigits;
    $[1] = locale;
    $[2] = value;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
};
export default Money;